import Vue from 'vue'

import manage from "@/core/api/manage.serve"//管理的接口的


const apis={
  manage,
}
export default {
  install() {
    Vue.prototype.$apis = apis
  }
}



// WEBPACK FOOTER //
// ./src/core/api/config/index.js